import { ConnectorIdRepository } from '../domain/ConnectorIdRepository';
import { ConnectorId } from '../domain/ConnectorId';
import { CommandDispatcher } from '@/modules/shared/domain/CommandDispatcher';
import { QueryDispatcher } from '@/modules/shared/domain/QueryDispatcher';
import { query_dispatcher , sync_command_dispatcher, async_command_dispatcher } from "@/api/client";

function objectToDict(obj: any): Record<string, any> {
    const dict: Record<string, any> = {};

    for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            const value = obj[key];
            if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
                // Recursively convert nested object
                dict[key] = objectToDict(value);
            } else {
                dict[key] = value;
            }
        }
    }

    return dict;
}

export class ApiConnectorIdRepository implements ConnectorIdRepository {

    command_dispatcher: CommandDispatcher
    query_dispatcher: QueryDispatcher
    constructor() {
        this.command_dispatcher = sync_command_dispatcher
        this.query_dispatcher = query_dispatcher
    }

    api_to_domain(connector) {
        return new ConnectorId(
            connector.user_id,
            connector.name,
            connector.current
        );
    }

    domain_to_api(connector: ConnectorId) {
        return JSON.parse(JSON.stringify(objectToDict(connector)));
    }
    
    async getConnectors(user_id: Number): Promise<ConnectorId[]> {
        let args = { 
            user_id: user_id,
        }
        let connectorData = await this.query_dispatcher.dispatch('get.connectorids', args)
        let connectorList: ConnectorId[] = []
        for (let connector in connectorData) {
            connectorList.push(this.api_to_domain(connectorData[connector]))
        }
        return connectorList
    }

    async setCurrentConnector(user_id: Number, current_name: String): Promise<void> {
        let args = { 
            user_id: user_id,
            current_name: current_name
        }
        await this.command_dispatcher.dispatch('set_current_connector', args)
    }
}
